module.exports = __webpack_public_path__ + "img/pro_four_6.96c01c98.jpg";